module.exports = __webpack_public_path__ + "img/en_921_page_title_white_pc.81fa06b2.png";